import { ClinicalCasesById } from "../modules"

export const ClinicalCasesByIDPage = () => {
  return (
    <ClinicalCasesById />
  )
}
